import React from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useApiKey } from '../context/ApiKeyContext';
import PersonalitySelection from '../components/PersonalitySelection';
import Layout from '../components/Layout';
import { generateCharacter } from '../utils/characterGenerator';

const VALID_GENDERS = ['male', 'female'];

const PersonalityPage = () => {
  const { isKeyValid, trialMode, trialBlock } = useApiKey();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const gender = searchParams.get('gender');

  const trialActive = trialMode && trialBlock !== 'trial_exhausted' && trialBlock !== 'owner_out_of_credits';
  const canPractice = isKeyValid || trialActive;

  // Gate: can't practice at all, or landed here without a gender (stale link,
  // hand-edited URL) — send back to the right earlier step.
  if (!canPractice) return <Navigate to="/" replace />;
  if (!VALID_GENDERS.includes(gender)) return <Navigate to="/" replace />;

  // This screen is Free Practice's personality picker: generate a character for
  // the chosen personality and hand off to the chat in free mode.
  const startFreePractice = (personality) => {
    const character = generateCharacter(personality, gender);
    navigate('/chat', { state: { personality, character, freeMode: true } });
  };

  return (
    <Layout>
      <PersonalitySelection
        gender={gender}
        onSelectPersonality={startFreePractice}
        onBack={() => navigate(`/mode?gender=${gender}`)}
      />
    </Layout>
  );
};

export default PersonalityPage;
